import { UserDetail } from '@/users/UserDetail'

export function UserDetailRoute() {
  return <UserDetail />
}
